<template>
  <div>
    <ul class="iv-declare-list">
      <li class="iv-p-b-24 iv-p-t-24" v-for="(item, i) in list" :key="i">
        <div class="iv-pull-left">
          <p class="iv-fs-16 iv-fc-65 iv-fw-b">
            <!-- 评审打分的状态 -->
            <span class="iv-m-r-8 iv-declare-title-tag iv-declare-green" v-if="type === 'review'">{{dictMap['BOE41'][item.reviewState]}}</span>
            {{item[map.title]}}
          </p>
          <p class="iv-fs-16 iv-fc-65 iv-m-t-12" v-if="type !== 'system' && type !== 'difficult' && type !=='voiceAdvice' && type !== 'questionnaire'">发布组织：{{item[map.orgName]}}</p>
          <p class="iv-fs-16 iv-fc-65 iv-m-t-12" v-if="type === 'questionnaire'">
            <span class="iv-declare-title-tag iv-declare-gray iv-m-r-8" v-if="item.questionnaireState == 1">未开始</span>
            <span class="iv-declare-title-tag iv-declare-yellow iv-m-r-8" v-if="item.questionnaireState == 2">进行中</span>
            <span class="iv-declare-title-tag iv-declare-gray iv-m-r-8" v-if="item.questionnaireState == 3">已结束</span>
            <span class="iv-declare-title-tag iv-declare-green iv-m-r-8" v-if="item.submitState == 2">已完成</span>
            <span class="iv-declare-title-tag iv-declare-red iv-m-r-8" v-if="item.submitState == 1">未参与</span>
          </p>
          <!-- 心声建议 -->
          <p class="iv-fs-16 iv-fc-65 iv-m-t-12" v-if="type === 'voiceAdvice'">提出日期：{{item[map.orgName]}}</p>
          <!-- 困难申请 difficult -->
          <p class="iv-fs-16 iv-fc-65 iv-m-t-12" v-if="type === 'difficult'">
            <span v-if="item.reportDate" class="iv-m-r-32">申请日期：{{timeFormat(item.reportDate)}}</span>
            <span>困难类别：{{dictMap['GG53'][item.poorType]}}</span>
          </p>
          <!-- 正常的 -->
          <p class="iv-fs-16 iv-fc-65 iv-m-t-12" v-if="type !== 'system' && type !== 'difficult' && type !=='voiceAdvice'">
            <span v-if="item[map.publishDate]" class="iv-m-r-32">发布日期：{{timeFormat(item[map.publishDate])}}</span>
            <span v-if="item[map.endDate]">截止日期：{{timeFormat(item[map.endDate])}}</span>
          </p>
          <!-- 心声建议 -->
          <p class="iv-fs-16 iv-fc-65 iv-m-t-12" v-if="type === 'voiceAdvice'">
            <span v-if="item[map.publishDate]" class="iv-m-r-32">处理状态：<span :class="item[map.publishDate] === '未反馈' ? '' : 'active'">{{ item[map.publishDate] }}</span></span>
            <span v-if="item[map.endDate]">意见类型：{{ item[map.endDate] }}</span>
          </p>
          <!-- 制度索引 system -->
          <p class="iv-fs-16 iv-fc-65 iv-m-t-16" v-if="type === 'system' && type !=='voiceAdvice'">
            <span>发布组织：{{item.publishOrg}}</span>
            <span class="iv-m-l-32">发布日期：{{timeFormat(item.publishDate)}}</span>
          </p>
          <!-- 困难申请 difficult -->
          <p class="iv-fs-16 iv-fc-65 iv-m-t-12" v-if="type === 'difficult'">
            <span class="iv-m-r-32">党组织认定情况：{{confirmStatusName(item.orgConfirmStatus)}}</span>
            <span>党组织帮扶情况：{{helpStatusName(item.orgHelpStatus)}}</span>
          </p>
          <p class="iv-fs-16 iv-fc-65 iv-m-t-12" v-if="type === 'difficult'">
            <span class="iv-m-r-32">工会组织认定情况：{{confirmStatusName(item.ghConfirmStatus)}}</span>
            <span>工会组织帮扶情况：{{helpStatusName(item.ghHelpStatus)}}</span>
          </p>
          <!--调查问卷-->
          <p class="iv-fs-16 iv-fc-65 iv-m-t-16" v-if="type === 'questionnaire'">
            <span>创建组织：{{item.createUnitName}}</span>
          </p>
          <p class="iv-fs-16 iv-fc-65 iv-m-t-16" v-if="type === 'questionnaire'">
            <span>创建人：{{item.createUserName}}</span>
            <span class="iv-m-l-32">问卷日期：{{timeFormat(item.beginDate) + '至' + timeFormat(item.endDate) }}</span>
          </p>
        </div>
        <div class="iv-pull-right iv-text-right">
          <!-- 评审打分的按钮 -->
          <span
            v-if="type === 'review' && v.isShow"
            class="iv-declare-list-right-btn iv-pointer iv-fc-85 iv-text-center iv-m-l-16"
            @click="toDetailPage(item, v)"
            v-for="v in item.btnList"
            :key="v.value">
            {{v.label}}
          </span>
          <span
            v-if="type === 'difficult' && item.reportStatus != 1"
            class="iv-declare-list-right-btn iv-pointer iv-fc-85 iv-text-center iv-m-l-16 iv-m-t-28" 
            @click="toDetailPage(item, 'update')">修改</span>
          <span
            v-if="type === 'difficult' && item.reportStatus != 1"
            class="iv-declare-list-right-btn iv-pointer iv-fc-85 iv-text-center iv-m-l-16 iv-m-t-28" 
            @click="toDetailPage(item, 'delete')">删除</span>
          <span
            v-if="type === 'difficult' && item.reportStatus == 1"
            class="iv-declare-list-right-btn iv-pointer iv-fc-85 iv-text-center iv-m-l-16 iv-m-t-28" 
            @click="toDetailPage(item, 'help')">查看帮扶情况</span>
          <span
            v-if="type === 'difficult' && item.reportStatus == 1"
            class="iv-declare-list-right-btn iv-pointer iv-fc-85 iv-text-center iv-m-l-16 iv-m-t-28" 
            @click="toDetailPage(item, 'detail')">查看困难申请单</span>
          <!-- 满意度调查 -->
          <span
            v-if="type === 'questionnaire' && item.questionnaireState != 3 && item.submitState == 1"
            class="iv-declare-list-right-btn iv-pointer iv-fc-85 iv-text-center iv-m-l-16 iv-m-t-28" 
            :class="{'iv-declare-disabled': item.questionnaireState == 1}"
            @click="toDetailPage(item, 'begin')">开始答卷</span>
          <span
            v-if="type === 'questionnaire' && item.questionnaireState != 1 && item.submitState == 2"
            :class="item.questionnaireState == 3 && item.submitState == 1 ? 'iv-declare-disabled' : ''"
            class="iv-declare-list-right-btn iv-pointer iv-fc-85 iv-text-center iv-m-l-16 iv-m-t-28" 
            @click="toDetailPage(item, 'questionnaireView')">查看详情</span>
          <span
            v-if="type !== 'review' && type !== 'difficult' && type !== 'questionnaire'"
            class="iv-declare-list-right-btn iv-pointer iv-fc-85 iv-text-center iv-m-l-16" 
            :class="{'iv-m-t-12': type === 'system'}" 
            @click="toDetailPage(item, 'detail')">
            {{computedName(item)}}
          </span>
          <!-- 评优申报 appraising -->
          <p class="iv-declare-list-right-bottom iv-fs-14 iv-fc-45 iv-m-t-32" v-if="type === 'appraising'">
            <span class="" v-if="item.isGetReward">
              <IconFont type="check-square" class="iv-m-r-8"></IconFont>已获奖
            </span>
            <span class="iv-m-l-24" v-if="item.isSignUp">
              <IconFont type="check-square" class="iv-m-r-8"></IconFont>已报名
            </span>
            <span class="iv-m-l-24" v-if="item.isReturnModify">
              <IconFont type="close-square" class="iv-m-r-8 iv-back-icon"></IconFont>返回修改
            </span>
          </p>
          <!-- 项目申报 project -->
          <p class="iv-declare-list-right-bottom iv-fs-14 iv-fc-45 iv-m-t-32" v-if="type === 'project'">
            <span class="iv-m-l-24" v-if="item.isGetReward">
              <IconFont type="check-square" class="iv-m-r-8"></IconFont>申请成功
            </span>
            <span class="iv-m-l-24" v-if="item.isSignUp">
              <IconFont type="check-square" class="iv-m-r-8"></IconFont>我已报名
            </span>
            <span class="iv-m-l-24"  v-if="item.isReturnModify">
              <IconFont type="close-square" class="iv-m-r-8 iv-back-icon"></IconFont>返回修改
            </span>
          </p>
          <!-- 活动报名 project -->
          <p class="iv-declare-list-right-bottom iv-fs-14 iv-fc-45 iv-m-t-32" v-if="type === 'activity'">
            <span class="iv-m-l-24" v-if="item.listState && item.listState == 'MDZT02'">
              <IconFont type="check-square" class="iv-m-r-8"></IconFont>{{item.listStateMap[item.listState]}}
            </span>
            <span class="iv-m-l-24" v-if="item.reportState && item.reportState == 'BMZT02'">
              <IconFont type="check-square" class="iv-m-r-8"></IconFont>{{item.reportStateMap[item.reportState]}}
            </span>
            <span class="iv-m-l-24" v-if="item.updateState && item.updateState == 'JLXGZT01'">
              <IconFont type="close-square" class="iv-m-r-8 iv-back-icon"></IconFont>{{item.updateStateMap[item.updateState]}}
            </span>
          </p>
          <!-- 评审 review -->
          <p class="iv-declare-list-right-bottom iv-fs-14 iv-fc-45 iv-m-t-32" v-if="type === 'review'">
            <span class="iv-declare-list-res">
              <em class="iv-finish-em"></em>{{dictMap['BOE411']['PSZT01']}}
            </span>
            <span class="iv-m-l-24 iv-declare-list-res">
              <em :class="{'iv-finish-em': item.scoreState === 'PSZT02' || item.scoreState === 'PSZT03'}"></em>{{dictMap['BOE411']['PSZT02']}}
            </span>
            <span class="iv-m-l-24 iv-declare-list-res">
              <em :class="{'iv-finish-em': item.scoreState === 'PSZT03'}"></em>{{dictMap['BOE411']['PSZT03']}}
            </span>
          </p>
          <!-- 心声建议 -->
          <span
            v-if="type === 'voiceAdvice' && item.handleState == '草稿'"
            class="iv-declare-list-right-btn iv-pointer iv-fc-85 iv-text-center iv-m-l-16 iv-m-t-28" 
            @click="toDetailPage(item, 'delete')">删除</span>
        </div>
      </li>
    </ul>
    <Page v-if="showPage" :total="total" :current="current" :pageSize="pageSize" class="iv-text-center iv-m-t-40" @on-change="changePage" @on-page-size-change="changePageSize"></Page>
  </div>
</template>

<script>
import { timeFormat } from '@/utils'
import Page from '@/components/page'
import IconFont from '@/components/iconfont'

export default {
  props: {
    list: {
      type: Array,
      default () {
        return []
      }
    },
    type: {
      type: String,
      default: 'appraising'
    },
    showPage: {
      type: Boolean,
      default: false
    },
    total: {
      type: Number,
      default: 1
    },
    current: {
      type: Number,
      default: 1
    },
    pageSize: {
      type: Number,
      default: 5
    },
    map: {
      type: Object,
      default () {
        return {
          title: 'reviewInfoName',
          orgName: 'initiateOrgName',
          publishDate: 'publicTime',
          endDate: 'endDate'
        }
      }
    }
  },
  data () {
    return {
      dictMap: {
        'BOE41': {},
        'BOE411': {},
        'GG53': {}
      }
    }
  },
  created () {
    this.getCodeTable('BOE41')
    this.getCodeTable('BOE411')
    this.getCodeTable('GG53')
  },
  methods: {
    timeFormat,
    computedName (item) {
      if (this.type === 'system') {
        return '下载附件'
      } else {
        return '查看详情'
      }
    },
    confirmStatusName (confirmStatus) {
      if (confirmStatus == '1_DJ_ZZ') {
        return '总支认定'
      } else if (confirmStatus == '1_DJ_DW') {
        return '党委认定'
      } else if (confirmStatus == '1_GH_XD') {
        return '现地认定'
      } else if (confirmStatus == '1_GH_JT') {
        return '集团认定'
      } else if (confirmStatus == '2_DJ_ZZ') {
        return '总支不认定'
      } else if (confirmStatus == '2_DJ_DW') {
        return '党委不认定'
      } else if (confirmStatus == '2_GH_XD') {
        return '现地不认定'
      } else if (confirmStatus == '2_GH_JT') {
        return '集团不认定'
      } else if (confirmStatus === '1') {
        return '已认定'
      } else if (confirmStatus == '2') {
        return '不认定'
      } else if (confirmStatus == '3') {
        return '待认定'
      }
    },
    helpStatusName (helpStatus) {
      if (helpStatus === 'draft' || helpStatus === 'disApprove') {
        return '未帮扶'
      } else if (helpStatus == 'pending') {
        return '审批中'
      } else if (helpStatus == 'approved') {
        return '已帮扶'
      }
    },
    changePage (page) {
      this.$emit('on-change', page)
    },
    changePageSize (page) {
      this.$emit('on-page-size-change', page)
    },
    //查看详情
    toDetailPage () {
      this.$emit('on-detail', ...arguments)
    },
    //数据字典
    getCodeTable (code) {
      this.$ajax({
        url: 'api-general/module/portal/user/outGetList',
        method: 'get',
        data: {
          dictCode: code,
          merge: false,
          bizLineCode: 'YWX01'
        }
      }).then(({data}) => {
        this.dictMap[code] = {}
        data.data.length &&  data.data.forEach(item => {
          if (!this.dictMap[code][item.value]) {
            this.dictMap[code][item.value] = item.title
          }
        })
      })
    }
  },
  components: {
    Page,
    IconFont
  }
}
</script>

<style lang="scss" scoped>
@import '@/assets/css/base/variable.scss';
.iv-declare-list {
  .active {
    color: #45BC7D;
  }
  li {
    overflow: hidden;
    border-bottom: 1px dashed rgba(0, 0, 0, 0.15);
    .iv-declare-title-tag {
      padding: 3px 8px;
      border-radius: 4px;
      border: 1px solid #45BC7D;
      font-size: 14px;
      font-weight: normal;
      &.iv-declare-green{
        border-color: #45BC7D;
      }
      &.iv-declare-yellow{
        border-color: #FFC757;
      }
      &.iv-declare-red{
        border-color: #FA2900;
      }
      &.iv-declare-gray{
        border-color: rgba(0, 0, 0, 0.45);
      }
    }
    &.iv-declare-green{
      border-color: #45BC7D;
    }
    &.iv-declare-yellow{
      border-color: #FFC757;
    }
    &.iv-declare-red{
      border-color: #FA2900;
    }
    &.iv-declare-gray{
      border-color: rgba(0, 0, 0, 0.45);
    }
    .iv-declare-green {
      color: #45BC7D;
    }
    .iv-declare-yellow {
      color: #FFC757;
    }
    .iv-declare-list-right-btn {
      display: inline-block;
      width: 108px;
      height: 40px;
      line-height: 40px;
      font-size: 14px;
      border-radius: 20px;
      border: 1px solid rgba(0, 0, 0, 0.25);
      &:hover {
        color: $iv-main-hover-color !important;
        border-color: $iv-main-hover-color !important;
      }
    }
    .iv-declare-list-right-bottom {
      .iconfont {
        color: #45BC7D;
      }
      .iv-back-icon {
        color: $iv-main-border-color;
      }
      .iv-declare-list-res {
        position: relative;
        padding-left: 22px;
        em {
          position: absolute;
          left: 0;
          top: 50%;
          margin-top: -7px;
          display: inline-block;
          width: 14px;
          height: 14px;
          border-radius: 50%;
          border: 1px solid rgba(0, 0, 0, 0.25);
        }
        .iv-finish-em {
          border-color: #45BC7D;
          border-width: 4px;
        }
      }
    }
    .iv-declare-gray {
      color: #979797;
    }
    .iv-declare-red {
      color: #FA2900
    }
    .iv-declare-disabled {
      background: #F5F7FA;
      border: 1px solid #D0D2D4;
      color: #B7B9BB!important;
      cursor: not-allowed;
      &:hover {
        color: #B7B9BB !important;
        border-color: #D0D2D4 !important;
      }
    }
  }
}
</style>
